import React, { useMemo } from 'react'
import { matchPath } from 'react-router'
import { useAppSelector } from 'hooks/reduxHooks'
import SiteTakeoverOfferPageBanner from 'takeovers/utils/components/SiteTakeoverOfferPageBanner'
import SiteTakeoverPageBanner from 'takeovers/utils/components/SiteTakeoverPageBanner'
import SiteTakeoverSearchBanner from 'takeovers/utils/components/SiteTakeoverSearchBanner'
import SiteTakeoverHomeBanner from 'takeovers/utils/components/SiteTakeoverHomeBanner'

/**
 * Page routes that would show this banner
 */
const homePageRoutes: Array<string> = [
  '/:regionCode',
]

const searchPageRoutes: Array<string> = [
  '/:regionCode/search',
  '/:regionCode/search/map',
  '/:regionCode/search/homes-and-villas',
  '/:regionCode/search/homes-and-villas/map',
]

const offerPageRoutes: Array<string> = [
  '/:regionCode/offer/:slug/:offerId',
  '/:regionCode/partner/:slug/:offerId',
  '/:regionCode/tour/:offerId',
  '/:regionCode/tour/:slug/:offerId',
  '/:regionCode/cruises/:offerId',
  '/:regionCode/cruises/:slug/:offerId',
]

/**
 * Page routes that would not show this banner
 */
const noBannerRoutes: Array<string> = [
  '/:regionCode/checkout',
  '/:regionCode/account',
  '/:regionCode/booking',
  '/:regionCode/bb/booking',
  '/:regionCode/trip-planner/generate-trip',
]

interface Props {
  vertical?: App.SiteTakeoverVertical
}
/**
 * This component is a wrapper for different banner types. Path matching to decide which banner type happens here.
 */
function SiteTakeoverTemplateBanner({ vertical }: Props) {
  const currentPath = useAppSelector(state => state.router.location.pathname)

  const shouldHide = useMemo(() => {
    return !!matchPath(currentPath, { path: noBannerRoutes })
  }, [currentPath])

  const currentPageType = useMemo((): 'home' | 'search' | 'offer' | 'generic' => {
    if (matchPath(currentPath, { path: offerPageRoutes })) {
      return 'offer'
    }
    if (matchPath(currentPath, { path: searchPageRoutes })) {
      return 'search'
    }
    if (matchPath(currentPath, { path: homePageRoutes, exact: true })) {
      return 'home'
    }
    return 'generic'
  }, [currentPath])

  if (shouldHide) {
    return null
  }

  if (currentPageType === 'home') {
    return <SiteTakeoverHomeBanner />
  } else if (currentPageType === 'search') {
    return <SiteTakeoverSearchBanner vertical={vertical} />
  } else if (currentPageType === 'offer') {
    return <SiteTakeoverOfferPageBanner />
  } else if (currentPageType === 'generic') {
    return <SiteTakeoverPageBanner />
  }
  return null
}

export default SiteTakeoverTemplateBanner
